import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Logger from './logger';

import MainBase from './views/MainBase';
import { configureStore } from './store/createStore';
import { BrowserRouter } from 'react-router-dom';
import { saveStoreInWindowOnNonProd } from 'utils';
import { AnalyticsAttributes } from 'components';
import { SmartagentChatWebsocketType } from '@missionlabs/smartagent-bchat';

declare global {
    interface Window {
        bchat: SmartagentChatWebsocketType
    }
}

Logger.init();

const persistedState = localStorage.getItem('state')
    ? JSON.parse(localStorage.getItem('state') || '')
    : {};

const store = configureStore(persistedState);

saveStoreInWindowOnNonProd(store);

function getBaseName() {
    return process.env.PUBLIC_URL || process.env.REACT_APP_PREFIX || '';
}
class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter basename={getBaseName()}>
                    <AnalyticsAttributes>
                        <MainBase />
                    </AnalyticsAttributes>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default App;
